import { useKeycloak } from '@react-keycloak/web';
import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';

export function useAuthUserInfo() {
    const { keycloak } = useKeycloak();
    const [userInfo, setUserInfo] = useState<unknown>();

    useEffect(() => {
        keycloak.loadUserInfo().then(value => {
            setUserInfo(value);
        });
    }, [keycloak]);

    return userInfo;
}

export function useOidcAuthUserInfo() {
    const [userInfo, setUserInfo] = useState<unknown>();
    const auth = useAuth();
    useEffect(() => {
        if (auth.user) {
            setUserInfo(auth.user);
        }
    }, [auth]);

    return userInfo;
}
